import {useEffect, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useUnit} from 'effector-react';
import {useForm} from 'react-hook-form';
import {
    $applicationInfo,
    $selectedApplication,
    resetApplicationEv, submitAppUpdateEv
    // downloadAppFileEv, downloadAppFileFx,
} from '../../models/applicationsModel/index.js';
import {classNames} from 'primereact/utils';
import {Sidebar} from 'primereact/sidebar';
import {Card} from 'primereact/card';
import {Skeleton} from 'primereact/skeleton';
import {DataView} from 'primereact/dataview';
import {Button} from 'primereact/button';
import {InputText} from 'primereact/inputtext';
import {Accordion, AccordionTab} from 'primereact/accordion';
import SkeletonCard from '../SkeletonCard/SkeletonCard.jsx';
import {Link} from 'react-router-dom';

export default function ApplicationInfoBar() {
    const {t} = useTranslation()
    const visible = useUnit($selectedApplication)
    const resetAppl = useUnit(resetApplicationEv)
    const appInfo = useUnit($applicationInfo)

    const submitApplication = useUnit(submitAppUpdateEv)
    // const downloadFile = useUnit(downloadAppFileEv)
    // const downloading = useUnit(downloadAppFileFx.pending)

    const {
        register,
        setValue,
        formState: {errors},
        handleSubmit
    } = useForm()

    useEffect(() => {
        if (appInfo && appInfo?.response_message && appInfo?.response_message.length > 0) {
            setValue('response_message', appInfo?.response_message)
        }
    }, [appInfo, setValue]);

    const firstCardInfo = useMemo(() => {
        if (appInfo) {
            return Object.fromEntries(
                Object.entries(appInfo)
                    .filter(([key]) => ['application_date', 'category', 'message', 'status'].includes(key))
            )
        } else return []
    }, [appInfo])

    const secondCardInfo = useMemo(() => {
        if (appInfo) {
            return Object.fromEntries(
                Object.entries(appInfo)
                    .filter(([key]) => ['applicant_fullname', 'applicant_bin', 'organization', 'response_message'].includes(key))
            )
        } else return []
    }, [appInfo])

    const itemTemplate = (key, value, index) => {
        return (
            <div className="col-12" key={index}>
                <div className={classNames('flex p-2 gap-2', { 'border-top-1 surface-border': index !== 0 })}>
                    <div className="flex justify-content-between align-items-center flex-1 gap-8">
                        <span className="font-bold text-900">{t(`applications.${key}`)}</span>
                        <span className="font-semibold">{key === 'status' ? t(`app_status.${value}`) : value}</span>
                    </div>
                    </div>
            </div>
        );
    };

    const listTemplate = (data) => {
        if (!data) return [];
        let list = Object.entries(data).map(([key, value], index) => {
            return itemTemplate(key, value, index);
        });

        return <div className="grid grid-nogutter">{list}</div>;
    }

    const files = appInfo?.documents?.map((d) => ({
        type: appInfo?.texts?.find(i => i.name === d.name)?.content ?? d.name,
        url: d.file.replace('http', 'https'),
        link_url: d.file
    }))

    return <Sidebar visible={visible}
                    onHide={() => resetAppl()}
                    position={'right'}
                    className={'w-5'}
    >
        {appInfo
            ? <div className={'flex flex-wrap gap-3'}>
                <Card title={`${t('Информация о заявке')} ${appInfo.id}`} className={'w-full'} pt={{content: {className: 'py-1'}}}>
                    <DataView value={firstCardInfo} listTemplate={listTemplate}/>
                    <Accordion>
                        <AccordionTab header={t('Файлы')}
                                      pt={{headerAction: () => ({className: 'p-2 mt-2'})}}
                        >
                            {files && files?.length > 0 && <div className={'flex flex-column gap-2'}>
                                {/*{files.map((f, i) => <span*/}
                                {/*    className={downloading ? 'text-grey-500' : 'text-green-500 hover:underline'}*/}
                                {/*    style={{cursor: 'pointer'}}*/}
                                {/*    key={i}*/}
                                {/*    onClick={() => downloadFile({path: f.url, name: f.type})}*/}
                                {/*>*/}
                                {/*    {f.type}*/}
                                {/*</span>)}*/}
                                Ссылки на скачивание:
                                {files.map((f, i) => <Link to={f.url}
                                    className={'text-green-500 hover:underline'}
                                    key={i}
                                >
                                    {f.type}
                                </Link>)}
                            </div>}
                        </AccordionTab>
                    </Accordion>
                </Card>
                <Card title={t('Заявитель')} className={'w-full'} pt={{content: {className: 'py-1'}}}>
                    <DataView value={secondCardInfo} listTemplate={listTemplate}/>
                </Card>
                {appInfo?.status === 'in_progress' &&
                    <form
                        onSubmit={handleSubmit((data) => submitApplication(data))}
                        className={'w-full'}
                    >
                    <InputText placeholder={t('Введите ответ')}
                               className={'w-full'}
                               invalid={!!errors.answer}
                               {...register('provider_comment', {required: t('Пожалуйста, введите обоснование')})}
                    />
                    {errors.answer && <small className="p-error">{errors.answer.message}</small>}
                    <div className="flex justify-content-between mt-3 w-full">
                        <Button severity={'danger'}
                                label={t('Отказать')}
                                className={'w-5'}
                                onClick={() => setValue('type', 'rejected')}
                        />
                        <Button severity={'success'}
                                label={t('Принять')}
                                className={'w-5'}
                                onClick={() => setValue('type', 'approved')}
                        />
                    </div>
                </form>}
            </div>
            : <div className={'flex flex-wrap gap-3'}>
                <SkeletonCard/>
                <SkeletonCard/>
                <div className="flex justify-content-between mt-3 w-full">
                    <Skeleton className={'w-5'} height="2rem"/>
                    <Skeleton className={'w-5'} height="2rem"/>
                </div>
            </div>
        }
    </Sidebar>
}